import React, { useState } from 'react';
import { Pencil, Trash2, Check, X, Plus } from 'lucide-react';
import { useFrameworks } from '../../context/FrameworksContext';
export function CategoryManager() {
  const {
    categories,
    frameworks,
    addCategory,
    updateCategory,
    deleteCategory
  } = useFrameworks();
  const [isAdding, setIsAdding] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [editingCategory, setEditingCategory] = useState<string | null>(null);
  const [editName, setEditName] = useState('');
  const [deletingCategory, setDeletingCategory] = useState<string | null>(null);
  const handleAdd = () => {
    if (newCategoryName.trim() && !categories.includes(newCategoryName.trim())) {
      addCategory(newCategoryName.trim());
      setNewCategoryName('');
      setIsAdding(false);
    }
  };
  const handleUpdate = (oldName: string) => {
    if (editName.trim() && editName.trim() !== oldName && !categories.includes(editName.trim())) {
      updateCategory(oldName, editName.trim());
    }
    setEditingCategory(null);
  };
  const handleDelete = (category: string) => {
    const frameworksInCategory = frameworks.filter(f => f.category === category);
    if (frameworksInCategory.length > 0) {
      alert(`Cannot delete category "${category}" because it contains ${frameworksInCategory.length} framework(s). Please reassign or delete them first.`);
      setDeletingCategory(null);
      return;
    }
    deleteCategory(category);
    setDeletingCategory(null);
  };
  return <div className="p-4 border-b border-slate-200 dark:border-slate-800 bg-slate-100/50 dark:bg-slate-800/20" data-id="element-26">
      <div className="flex items-center justify-between mb-3" data-id="element-27">
        <h3 className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-28">
          Manage Categories
        </h3>
        <button onClick={() => setIsAdding(true)} className="p-1 text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" title="Add Category" data-id="element-29">
          <Plus className="w-4 h-4" data-id="element-30" />
        </button>
      </div>

      <div className="space-y-2" data-id="element-31">
        {isAdding && <div className="flex items-center gap-2" data-id="element-32">
            <input type="text" value={newCategoryName} onChange={e => setNewCategoryName(e.target.value)} placeholder="New category..." className="flex-1 px-2 py-1 text-sm bg-white dark:bg-slate-950 border border-slate-300 dark:border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus onKeyDown={e => e.key === 'Enter' && handleAdd()} data-id="element-33" />
            <button onClick={handleAdd} className="p-1 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 rounded" data-id="element-34">
              <Check className="w-4 h-4" data-id="element-35" />
            </button>
            <button onClick={() => setIsAdding(false)} className="p-1 text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded" data-id="element-36">
              <X className="w-4 h-4" data-id="element-37" />
            </button>
          </div>}

        {categories.map(category => <div key={category} className="flex items-center justify-between group text-sm" data-id="element-38">
            {editingCategory === category ? <div className="flex items-center gap-2 w-full" data-id="element-39">
                <input type="text" value={editName} onChange={e => setEditName(e.target.value)} className="flex-1 px-2 py-1 text-sm bg-white dark:bg-slate-950 border border-slate-300 dark:border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus onKeyDown={e => e.key === 'Enter' && handleUpdate(category)} data-id="element-40" />
                <button onClick={() => handleUpdate(category)} className="p-1 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 rounded" data-id="element-41">
                  <Check className="w-4 h-4" data-id="element-42" />
                </button>
                <button onClick={() => setEditingCategory(null)} className="p-1 text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded" data-id="element-43">
                  <X className="w-4 h-4" data-id="element-44" />
                </button>
              </div> : deletingCategory === category ? <div className="flex items-center justify-between w-full bg-red-50 dark:bg-red-900/20 px-2 py-1 rounded-md border border-red-200 dark:border-red-800/50" data-id="element-45">
                <span className="text-xs text-red-600 dark:text-red-400 font-medium" data-id="element-46">
                  Delete?
                </span>
                <div className="flex gap-1" data-id="element-47">
                  <button onClick={() => handleDelete(category)} className="px-2 py-0.5 text-xs bg-red-600 text-white rounded hover:bg-red-700" data-id="element-48">
                    Yes
                  </button>
                  <button onClick={() => setDeletingCategory(null)} className="px-2 py-0.5 text-xs bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 rounded hover:bg-slate-300 dark:hover:bg-slate-600" data-id="element-49">
                    No
                  </button>
                </div>
              </div> : <>
                <span className="text-slate-700 dark:text-slate-300 truncate pr-2" data-id="element-50">
                  {category}
                </span>
                <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-51">
                  <button onClick={() => {
              setEditingCategory(category);
              setEditName(category);
            }} className="p-1 text-slate-400 hover:text-blue-600 dark:hover:text-blue-400" data-id="element-52">
                    <Pencil className="w-3.5 h-3.5" data-id="element-53" />
                  </button>
                  <button onClick={() => setDeletingCategory(category)} className="p-1 text-slate-400 hover:text-red-600 dark:hover:text-red-400" data-id="element-54">
                    <Trash2 className="w-3.5 h-3.5" data-id="element-55" />
                  </button>
                </div>
              </>}
          </div>)}
      </div>
    </div>;
}